import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import WorkExperience from './components/WorkExperience';
import LeadershipExperience from './components/LeadershipExperience';
import Education from './components/Education';
import Extracurriculars from './components/Extracurriculars';
import Contact from './components/Contact';
import './App.css';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <WorkExperience />
      <LeadershipExperience />
      <Education />
      <Extracurriculars />
      <Contact />
    </div>
  );
}

export default App;
